import React from 'react';


import { Box } from '@mui/material';

const Logo = () => (
    <Box sx={{ textAlign: 'center', mb: 4 }}>
        <img 
            src="https://mlmcrrcosgmc.i.optimole.com/w:auto/h:auto/q:mauto/ig:avif/https://i0.wp.com/jaredvallejo.com/wp-content/uploads/2024/12/javcon.png" 
            alt="Logo" 
            style={{ 
                maxWidth: '400px', 
                height: 'auto' 
            }} 
        />
    </Box>
);

export default Logo;
